import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { AlertCircle } from 'lucide-react';

const DisclaimerPage = () => {
  return (
    <div className="min-h-screen">
      <Header />
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="glass-card-md p-8" data-testid="disclaimer-content">
          <div className="flex items-center mb-6">
            <AlertCircle className="w-10 h-10 text-blue-500 mr-3" />
            <h1 className="text-4xl sm:text-5xl tracking-tight font-semibold text-white">Tıbbi Sorumluluk Reddi</h1>
          </div>
          <div className="prose prose-slate max-w-none">
            <div className="bg-red-50 border border-red-200 rounded-xl p-6 mb-6">
              <h2 className="text-2xl font-medium text-red-800 mb-3">ÖNEMLİ UYARI</h2>
              <p className="text-red-700 font-medium">Bu platform bir AI sağlık asistanıdır ve tıbbi teşhis koymaz!</p>
            </div>

            <h2 className="text-2xl font-medium text-white/90 mt-6 mb-3">Genel Bilgilendirme</h2>
            <p className="text-white/70 mb-4">Doktor Cebinde platformu kişisel takip ve destek amaçlı bir sağlık asistanıdır. Bu platform:</p>
            <ul className="list-disc pl-6 text-white/70 space-y-2 mb-6">
              <li><strong>Tıbbi teşhis koymaz</strong></li>
              <li><strong>Tıbbi tavsiye vermez</strong></li>
              <li><strong>Acil sağlık hizmeti yerine geçmez</strong></li>
              <li><strong>Profesyonel sağlık hizmeti yerine geçmez</strong></li>
            </ul>

            <h2 className="text-2xl font-medium text-white/90 mt-6 mb-3">Ne Zaman Profesyonel Yardım Almalısınız</h2>
            <ul className="list-disc pl-6 text-white/70 space-y-2 mb-6">
              <li>Ciddi veya devam eden belirtiler yaşıyorsanız</li>
              <li>Acil bir durum söz konusuysa (112'yi arayın)</li>
              <li>Kendinize veya başkalarına zarar verme düşünceleriniz varsa</li>
              <li>Mevcut bir tıbbi durumunuz varsa</li>
              <li>Herhangi bir endişeniz veya sorunuz varsa</li>
            </ul>

            <h2 className="text-2xl font-medium text-white/90 mt-6 mb-3">Sorumluluk Sınırı</h2>
            <p className="text-white/70 mb-4">
              Platformu kullanarak, verilen bilgilerin sadece genel bilgilendirme amaçlı olduğunu ve profesyonel tıbbi tavsiye yerine geçmediğini kabul edersiniz.
            </p>
            <p className="text-white/70">
              Her zaman lisanslı bir sağlık profesyoneline danışın ve platformdaki bilgileri kendi kararlarınızın tek kaynağı olarak kullanmayın.
            </p>

            <h2 className="text-2xl font-medium text-white/90 mt-6 mb-3">Acil Durumlar</h2>
            <div className="glass-card rounded-xl p-4">
              <p className="text-white/70 font-medium">Acil bir tıbbi durum durumunda hemen <span className="text-red-600 font-bold">112</span>'yi arayın veya en yakın acil servise gidin.</p>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default DisclaimerPage;